import { PaymentTypes } from '@cashier/cashier-model';

export const DEFAULT_MIN_AMOUNT = 10;

export const defaultMaxAmountsMap = {
  [PaymentTypes.Deposit]: 100000,
  [PaymentTypes.Withdrawal]: 4000,
};
